var $cookie_domain = window.location.hostname.split('.').slice(-2).join('.');
(function($, window, document, undefined) {
	vex.defaultOptions.className = 'vex-theme-park';

	function ul_width() {
		$('.div-padding-personal ul').each(function() {
			if ($(this).next().is('ul')) {
				if ($(window).width() > 640) {
					$(this).css('width', '45%');
				} else {
					$(this).css({
						'width': '100%',
						'margin-bottom': '0'
					});
				}
			}
		});
	}

	/*
	 *
	 * Equal Height jQuery Snippet.  Using this for footer and grid accordion
	 *
	 */
	var equalheight = function(container) {
		var currentTallest = 0,
			currentRowStart = 0,
			rowDivs = [],
			$el,
			topPosition = 0,
			currentDiv;

		$(container).each(function() {
			$el = $(this);
			$el.height('auto');
			topPosition = $el.position().top;
			if (currentRowStart < topPosition - 1 || currentRowStart > topPosition + 1) {
				for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
					rowDivs[currentDiv].height(currentTallest);
				}
				rowDivs = [];
				currentRowStart = topPosition;
				currentTallest = $el.height();
				rowDivs.push($el);
			} else {
				rowDivs.push($el);
				currentTallest = Math.max(currentTallest, $el.height());
			}
		});

		for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
			rowDivs[currentDiv].css('height', currentTallest);
		}
	};

	function jumpLinkClick(){
        if($('.meet-team__jumplinks').length){

           $(".meet-team__jumplinks a").on('click', function(event) {

				// Make sure this.hash has a value before overriding default behavior
				if (this.hash !== "") {

					event.preventDefault();

					var hash = this.hash;

					$('html, body').animate({
						scrollTop: $(hash).offset().top
					}, 800);

				}
			});
        }
    }

    /*------------------------------------------------------------------------------
    Calendly
    ------------------------------------------------------------------------------*/

    var CalendlyModule = function()
    {
        $(".calendly-module").each(function()
        {
            var mod = $(this);
            mod.find('[name="appointment-location"]').change(function()
            {
                var oldhei = mod.height();
                var locations = mod.find(".calendly-locations");
                var visibleWidgets = mod.find(".calendly-inline-widget:visible");
                var widget = mod.find($(this).data("schedule"));

                locations.fadeOut(250, function()
                {
                    var newhei = widget.height();
                    widget.css({ 'opacity': 0, 'height': oldhei + "px" })
                        .show()
                        .animate(
                            { opacity: 1, height: newhei + "px" },
                            { queue: false, duration: 250 }
                        );
                });
            });
        });

        $(".calendly-btn").click(function(e)
        {
            e.preventDefault();

            var parent = $(this).parents(".calendly-cta");
            parent.slideUp(function()
            {
                parent.siblings(".calendly-module").slideDown();
            });
        });
    }

	$(document).ready(function() {

		var $window = $(window);
		/* Unordered list floats */
		ul_width();

		equalheight('.vertical_center');

        new CalendlyModule();

        jumpLinkClick();

        $('body').rciBumper({
			links : PNBBumper.whitelist,
			confirmMessage : PNBBumper.message,
		});

		$('.download-trust-online-pdf label').on('click', (e) => {
			if ( '' != PNB_SETTINGS.trust_online_terms ) {
				window.open( PNB_SETTINGS.trust_online_terms, '_blank' );
			}
		});

		/* slick slider */
		if ( $.isFunction($.fn.slick) ) {
			$('.video__cards').slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				prevArrow: '<button type="button" class="slick-prev" title="Previous Video Slide"><i class="fas fa-chevron-left"></i></button>',
				nextArrow: '<button type="button" class="slick-next" title="Next Video Slide"><i class="fas fa-chevron-right"></i></button>',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							infinite: true,
						}
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			});
		}

		$('body').on('submit', '.js-tm-wizard-form', function(e){
			e.preventDefault();
			var $self = $(this);
			$.get( ajax_object.ajax_url, $(this).serialize(), function(data){
				$self.replaceWith( data );
			});
			return false;
		});

		$('body').on('click','.js-tm-cancel',function(e){
			e.preventDefault();
			var $self = $(this);
			$.get( $self.attr('href'), function(data){
				$self.parents('form').replaceWith(data);
			});
		});

		$('body').on('click','.js-ts-parent-link',function(e){

			if($(this).hasClass("active")) {
				return false;
			}

			e.preventDefault();
			$('.main-filter').removeClass('active');
			var $self = $(this);
			$.get( $self.data('url'), function( data ){
				$('.js-ts-specialties').replaceWith( data );
				$self.addClass('active');
			} );
		});

		//close mobile windows on resize up
		var currentStatus = 'open';
		$(window).resize(function(e) {
			if (currentStatus == 'open' && $window.width() > 1000) {
				$('header.main_header').removeClass('show-main-menu');
				$('body').removeClass('menu_open');
				//$('#login-toggle').parent().removeClass('mobile-expand');
				//$('.active-tab').removeClass('active-tab');
				//$('.show-tab').removeClass('show-tab');
				//$('#tab-main-menu').addClass('show-tab');
				currentStatus = 'closed';
				/*}else if($window.width() <= 1000){
				    currentStatus = 'open';
				    $('header.main_header').removeClass('show-main-menu');
				    $('#tab-main-menu').removeClass('show-tab');
				    //$('body').addClass('menu_open');
				    //$('#login-toggle').parent().addClass('mobile-expand');
				*/
			}
			if ($window.width() > 1000) {
				$('header.main_header').removeClass('show-main-menu');
				$('body').removeClass('menu_open');
				$('.tab-login').removeClass('show-tab');
				$('#tab-main-menu').addClass('show-tab');
				currentStatus = 'closed';
			}

		});

		//TOGGLE MOBILE MENU ACCORDION
		$('.mobile-menu-trigger').on('click', function(event) {
			event.preventDefault();
			$(this).parent().toggleClass('mobile-expand');
		});
		//TOGGLE MAIN NAV MENU LOGIN
		$('#login-toggle').on('click', function(event) {
			event.preventDefault();
			$(this).parent().toggleClass('active-login');
			$('body').toggleClass('active-login');
		});

		//TABS FOR MOBILE MENU
		$('.tab-trigger').on('click', function(event) {
			event.preventDefault();
			$('.active-tab').removeClass('active-tab');
			$('.show-tab').removeClass('show-tab');

			var obj = $(this);
			var tab = obj.data('tabid');
			obj.addClass('active-tab');
			$('#' + tab).addClass('show-tab');
			if (tab == "tab-branch") {
				$('#' + tab).find('.drawer').addClass('open');
				load_current_branch();
			}
		});

		$('.toggle-branch').on('click', function(event) {
			event.preventDefault();
			$('#BranchInfo').toggleClass('open');

			$('#tab-branch').toggleClass('slide-out');
			load_current_branch();
			$('#tab-branch').find('.close-button').on('click', function(e) {
				e.preventDefault();
				$('#tab-branch').removeClass('slide-out');
			});
		});

		//Boldchat
		$('.boldchat_button').on('click', function(e) {
			e.preventDefault();
			$('.bcFloat').find('a').click();
		});

		//SEARCH
		$('#search-icon').on('click', function(event) {
			event.preventDefault();
			$(this).toggleClass('active-search');
			$('#search-bar-container').toggleClass('show-search');
		});
		//SLIDE OUT MENU
		$('.slide-menu').on('click', function(event) {
			event.preventDefault();
			if ($(this).is('#mobile-login-icon')) {
				$('#mobile-tabs').find('.tab-trigger:eq(1)').click();
			}
			$('header.main_header').toggleClass('show-main-menu');
			$('body').toggleClass('menu_open');
			//$('body').remove('menu_open');
		});

		//Post Filtering on blog list page
		//$('.filter').on('click', function(e) {
		//e.preventDefault();
		// $(this).toggleClass('filter-active');
		//});
		//CLICK FUNCTION TO TOGGLE ACCORDION
		$('.accordion-header').on('click', function() {
			var obj = $(this);
			obj.parent().toggleClass('active-accordion');
		});

		//feedback module on blod detail page
		var $toggle_feedback = $('.feedback_cta').find('.toggle_feedback');
		$toggle_feedback.on('click', function(e) {
			e.preventDefault();
			$toggle_feedback.parents('.feedback_cta').hide();
			$('.feedback_form').show();
		});

		//Toggle Feedback controls based on positive/negative
		function toggleFeedback($elem) {
			var $context = $elem.data('context'),
				$actions = $('.feedback--actions');
			$actions.find('section').hide();
			var $element = $actions.find("section[data-context=" + $context + "]").show();
		}

		$('.list-filter').on('change', function(e) {
			e.preventDefault();
			var $list_selector = $(this).data('list'),
				$item_selector = $(this).data('item'),
				$value = this.value,
				$list = $($list_selector),
				$items = $($item_selector);

			if (this.value) {
				$items.hide();
				$list.find('.' + this.value).each(function() {
					$(this).show();
				});
				$list.find('.row-break').hide();
			} else {
				$items.show();
				$list.find('.row-break').show();
			}

		})

		//Desktop HP Login
		var $login_form = $('.login_form_wrap'),
			$login_form_select = $login_form.find('.form_select');

		$login_form_select.on('change', function() {
			var $auto_submit = [4, 5, 6, 7, 8];
			var $form_id = $(this).find(":selected").data('form');
			var $error_message = $(this).parent('.login_form_wrap').find('.form_block[data-form=form_' + $form_id + ']').find('.error_message');
			Cookies.set('default_login_form', $form_id, {
				expires: 1,
				path: '/',
				domain: $cookie_domain
			});
			dataLayer.push({
			  'cashManagementService':'GTM-N9VFNL4',
			  'event':'cashManagementLoginEvent'
			});
			if ($form_id) {
				if (jQuery.inArray($form_id, $auto_submit) > -1 && $error_message.length == 0) {
					var $selected_form = $(this).parent('.login_form_wrap').find('[data-form="form_' + $form_id + '"]')
					$(this).parent('.login_form_wrap').find('.form_block').hide();
					$(this).parent('.login_form_wrap').find('[data-form="form_' + $form_id + '"]').slideDown();
					if ($selected_form.find('.direct_link').length) {
						window.location = $selected_form.find('.direct_link').find('.button').attr('href');
					} else {
						$selected_form.find('form').submit();
					}

				} else {
					$(this).parent('.login_form_wrap').find('.form_block').hide();
					$(this).parent('.login_form_wrap').find('[data-form="form_' + $form_id + '"]').slideDown();
				}
                //business banking custom box
                if($form_id == 2){
                    $(this).parents('#hero-login, #sidebar-login').addClass('business_banking');
                    $(this).parent('.login_form_wrap').find('[data-form="form_2"]').addClass('business_banking');
                }else{
                    $(this).parents('#hero-login, #sidebar-login').removeClass('business_banking');
                    $(this).parent('.login_form_wrap').find('[data-form="form_2"]').removeClass('business_banking');
                }
			}
		});

		var default_login_form = getCookie('default_login_form');
		if (default_login_form) {
			$login_form_select.each(function() {
				$(this).find('option[data-form=' + default_login_form + ']').prop('selected', true);
				$(this).parent('.login_form_wrap').find('.form_block').hide();
				$(this).parent('.login_form_wrap').find('[data-form="form_' + default_login_form + '"]').show();
            });

            //business banking custom box
            if(default_login_form == 2){
                $login_form_select.parents('#hero-login, #sidebar-login').addClass('business_banking');
                $login_form_select.parent('.login_form_wrap').find('[data-form="form_2"]').addClass('business_banking');
            }else{
                $login_form_select.parents('#hero-login, #sidebar-login').removeClass('business_banking');
                $login_form_select.parent('.login_form_wrap').find('[data-form="form_2"]').removeClass('business_banking');
            }
		}

		var $login_forms = $('.form_block').find('form');
		$login_forms.each(function() {
			var $form = $(this),
				$parent = $(this).parents('.form_block'),
				$error_message = $parent.find('.error_message'),
				$error_message_passthrough = $error_message.data('passthrough'),
				$error_message_always = $error_message.data('always'),
				$error_message_cookie = $error_message.data('cookie'),
				$seen_cookie = !$error_message_always && getCookie($error_message_cookie),
				$agreement_message_cookie = 'LoginAgreement_' + $form.data('agreementCookie'),
				$agreement_cookie = getCookie($agreement_message_cookie);

				PNBDebug( 'Begin: ' + $parent.data('form'), LoginAlertBox.debug );
				PNBDebug( 'Message: ' + $error_message.text(), LoginAlertBox.debug);
				PNBDebug( 'Passthrough: ' + $error_message_passthrough, LoginAlertBox.debug);
				PNBDebug( 'Always: ' + $error_message_always, LoginAlertBox.debug);
				PNBDebug( 'Cookie: ' + $error_message_cookie, LoginAlertBox.debug);
				PNBDebug( 'Agreement Cookie: ' + $agreement_message_cookie, LoginAlertBox.debug);
				PNBDebug( 'End: ' + $parent.data('form'), LoginAlertBox.debug );

			$(this).on('submit', function(e) {
				PNBDebug( 'Checking: ' + $parent.data('form'), LoginAlertBox.debug );
				//digital terms modal
				if ( $form[0].hasAttribute('data-agreement-required') && !$agreement_cookie ) {
					PNBDebug( 'Has agreement modal: ' + $parent.data('form'), LoginAlertBox.debug );
					e.preventDefault();
					e.stopImmediatePropagation();
					//contains a form with checkboxes for requirements - used reportValidity for handling requirements
					let $content = [
						'<form id="LoginTermsConditions">',
						'<div class="modal_title">Digital Wealth Management Services<br>Terms and Conditions</div>',
						'<div class="modal_content">',
							'<div class="checkbox-button">',
							'<input type="checkbox" required id="AgreementDownload">',
							'<label for="AgreementDownload">View &amp; Download PDF</label>',
							'<p><small>To continue, please view the terms and conditions in the link above. If you are unable to access the terms and conditions, you will need to download the free version of <a href="https://get.adobe.com/reader/" target="_blank">Adobe Acrobat Reader</a> or configure your browser to use <a href="https://helpx.adobe.com/acrobat/using/display-pdf-in-browser.html" target="_blank">Adobe PDF plug-in</a>.</small></p>',
							'</div>',
							'<div>',
							'<input type="checkbox" required id="AgreementCheckbox">',
							'<label for="AgreementCheckbox">I Agree</label>',
							'<p><small>By clicking "I Agree" you agree to these Digital Service Terms and using the Services, you agree to these Digital Service Terms and further opt-in to receive information and documents from Park electronically, as further set forth in these Digital Service Terms.</small></p>',
							'</div>',
						'</div>',
						'<div class="modal_buttons"><button type="submit" class="button primary">Continue</button></div>',
						'</form>',
					];

					const $agreementModal = vex.open({
						unsafeContent: $content.join(''),
						//once html is in DOM, attach our various listeners
						afterOpen: function(){
							let form = document.getElementById('LoginTermsConditions'),
								download = form.querySelector('#AgreementDownload'),
								agree = form.querySelector('#AgreementCheckbox');

							//these take control of browser warning if not filled in
							download.setCustomValidity('Please view and download the pdf to continue.');
							download.addEventListener('click',(e) => {
								if(download.checked){
									download.setCustomValidity('');
									if ( '' != PNB_SETTINGS.trust_online_terms ) {
										window.open( PNB_SETTINGS.trust_online_terms, '_blank' );
									}
								}else{
									download.setCustomValidity('Please view and download the pdf to continue.');
								}
							});
							agree.setCustomValidity('Please agree to the terms and conditions to continue.');
							agree.addEventListener('click',(e) => {
								if(agree.checked){
									agree.setCustomValidity('');
								}else{
									agree.setCustomValidity('Please agree to the terms and conditions to continue.');
								}
							});

							//on successful submit, set cookie to bypass and submit form again - for continue or alert message
							form.addEventListener('submit',(e) => {
								e.preventDefault();
								e.stopImmediatePropagation();
								if ( form.reportValidity() ) {
									vex.closeAll();
									Cookies.set($agreement_message_cookie, true, {
										expires: 180,
										path: '/',
										domain: $cookie_domain
									});
									$agreement_cookie = true;
									$form.submit();
								}
							});
						}
					});
					return false;
				}
				//alert message modal
				if ($error_message.length && !$seen_cookie) {
					e.preventDefault();
					e.stopImmediatePropagation();
					var $content = [
						"<div class=\"modal_title\"><h3>" + $error_message.find('.message_title').html() + "</h3></div>",
						"<div class=\"modal_content\" style=\"text-align: center;\">" + $error_message.find('.message_content').html() + "</div>"
					];
					if (parseInt($error_message_passthrough) === 1) {
						$content[$content.length] = "<div class=\"modal_buttons\" style=\"text-align:center\"><a href=\"#\" class=\"button\" onClick=\"vex.closeAll();\">Continue</a></div>";
					} else {
						$content[$content.length] = "<div class=\"modal_buttons\"></div>";
					}
					PNBDebug( 'Modal: ' + $parent.data('form'), LoginAlertBox.debug );
					var $modal = vex.open({
						unsafeContent: $content.join(""),
						afterClose: function() {
							if (parseInt($error_message_passthrough) === 1) {
								PNBDebug( 'Passing Through: ' + $parent.data('form'), LoginAlertBox.debug );
								Cookies.set($error_message_cookie, true, {
									expires: 180,
									path: '/',
									domain: $cookie_domain
								});
								$seen_cookie = true;
								$form.submit();
							}
						}
					});

					return false;
				}
				/*else{
                	if (!$form.hasClass('filtered')) {
	                    e.preventDefault();
	                    $form.find('input').each(function() {
	                        $(this).val($(this).val().trim());
	                    }).addClass('filtered');
	                    $form[0].reset();
	                    $form.off('submit').submit();
	                }
	                $form[0].reset();
                }*/
                PNBDebug( 'Submitting: ' + $parent.data('form'), LoginAlertBox.debug );
				return true;
			});
		});

		function PNBDebug( mixed, flag ){
			if( !!+flag ){
				console.log( mixed );
			}
		}

        // bind change event to select
        $('.cash_management_submit').on('click', function () {
            var url = $(this).parent('.cash_management_block').find('.cm_select').val();
            if (url) { // require a URL
//                    window.location = url; // redirect
                window.open(url, '_blank');
            }
            return false;
        });


		var $post_filtering_form = $('.post_filtering_form');
		$post_filtering_form.find('.filter').on('click', function() {
			$(this).toggleClass('active');
			$post_filtering_form.submit();
		});

		//Glossary Functions
		$('abbr').on('click', function(e) {
			//e.preventDefault();
			var $title = $(this).data('title'),
				$id = $(this).data('id');
			if (!$('#glossaryTerm').hasClass('open')) {
				$('#glossaryTerm').addClass('open');
			}
			load_glossary_content($title, $id);
		});

		$('.drawer').find('.close-button').on('click', function(e) {
			e.preventDefault();
			$(this).parent('.drawer').removeClass('open');
		});

		var places_input = document.getElementById('PlaceSearch'),
			enterPressedInForm = false,
			canSubmit = false,
			placesForm = $(places_input).parents('form'),
			places_options = {
				types: ['geocode'],
				fields: ['geometry']
			},
			places_autocomplete = new google.maps.places.Autocomplete(places_input, places_options);

		placesForm.submit(function(e) {
			// Only submit the form if information has been stored in our hidden input
			var ret = ( canSubmit && ( $("#PlaceLat").val().length > 0 ) );
			return ret;
		});
		$(places_input).bind("keypress", function(e) {
			$(".places-error").remove();
			if( e.keyCode == 13 ) {
				// Note that simply triggering the 'place_changed' event in here would not suffice, as this would just create an object with the name as typed in the input field, and no other information, as that has still not been retrieved at this point.
				// We change this variable to indicate that enter has been pressed in our input field
				enterPressedInForm = true;
				if( $("#PlaceLat").val().length == 0 || !canSubmit ){
					$(places_input).parent().before( '<p class="places-error">Please select from the dropdown.</p>' );
					$(places_input).focus();
				}
			}
		});

		places_autocomplete.addListener('place_changed', function(){
			var place = places_autocomplete.getPlace();
			if( place.geometry !== undefined ){
				canSubmit = true;
				$("#PlaceLat").val( place.geometry.location.lat() );
				$("#PlaceLng").val( place.geometry.location.lng() );
			}else{

			}
			if(enterPressedInForm) {
				placesForm.submit();
			}
		});

		function load_current_branch() {
			var $drawer_location_ajax = $('.drawer_location_ajax'),
				$default_location = getCookie('default_location'),
				$default_site = getCookie('default_site');
			if ($drawer_location_ajax.is(':visible') || !$default_location) {
				return;
			}
			$drawer_location_ajax.show();
			var data = {
				action: "park_load_current_branch",
				default_location: $default_location,
				default_site: $default_site
			};
			$.ajax({
				url: ajax_object.ajax_url,
				type: "POST",
				data: data,
				success: function(data, textStatus, jqXHR) {
					var filtered = data.replace(/\\"/g, '"').replace('\\n', '').replace('\\t', '');
					$drawer_location_ajax.find('.loading_wrap').hide();
					$drawer_location_ajax.append($(filtered));
				},
				error: function(jqXHR, textStatus, errorThrown) {
					console.log(jqXHR);
					console.log(textStatus);
					console.log(errorThrown);
				}
			});
		}

		if (getCookie('default_location')) {
			load_default_location();
			load_contact_cta();
			load_contact_sticky_bar();
		}

		function load_default_location() {
			var $top_branch_indicator = $('#top-branch-indicator'),
				$default_location = getCookie('default_location'),
				$default_site = getCookie('default_site');

			var data = {
				action: "park_load_default_location",
				default_location: $default_location,
				default_site: $default_site
			};
			$.ajax({
				url: ajax_object.ajax_url,
				type: "POST",
				data: data,
				success: function(data, textStatus, jqXHR) {
					$top_branch_indicator.find('#current-branch').html(data.split('"').join(''));
                    $top_branch_indicator.find('.find_location').removeClass('active');
				},
				error: function(jqXHR, textStatus, errorThrown) {
					console.log(jqXHR);
					console.log(textStatus);
					console.log(errorThrown);
				}
			});
		}

		function load_contact_cta() {
			var $contact_person_container_ajax = $('.contact-person-container-ajax'),
				$default_location = getCookie('default_location'),
				$default_site = getCookie('default_site');

			if ($contact_person_container_ajax.length == 0) {
				return;
			}

			var data = {
				action: "park_load_location_contact_cta",
				default_location: $default_location,
				default_site: $default_site

			};
			$.ajax({
				url: ajax_object.ajax_url,
				type: "POST",
				data: data,
				success: function(data, textStatus, jqXHR) {
					var filtered = data.replace(/\\"/g, '').replace('\\n', '').replace('\\t', '');
					$contact_person_container_ajax.html($(filtered));
				},
				error: function(jqXHR, textStatus, errorThrown) {
					console.log(jqXHR);
					console.log(textStatus);
					console.log(errorThrown);
				}
			});
		}

		function load_contact_sticky_bar() {
			var $top_stick_cta = $('.top_stick_cta'),
				$default_location = getCookie('default_location'),
				$default_site = getCookie('default_site');

			if ($top_stick_cta.length == 0) {
				return;
			}

			var data = {
				action: "park_load_contact_sticky_bar",
				default_location: $default_location,
				default_site: $default_site
			};
			$.ajax({
				url: ajax_object.ajax_url,
				type: "POST",
				data: data,
				success: function(data, textStatus, jqXHR) {
					$top_stick_cta.find('.cta_content').find('.branch_manager').html($(data.content));
					if (data.manager_name !== "") {
						$top_stick_cta.find('.cta_toggle_content').find('.need_assistance').find('.manager_name').text(data.manager_name);
					}
					$top_stick_cta.find('.cta_toggle_content').find('.manager_headshot').html($(data.manager_headshot));
				},
				error: function(jqXHR, textStatus, errorThrown) {
					console.log(jqXHR);
					console.log(textStatus);
					console.log(errorThrown);
				}
			});
		}

		//Sticky Table Header

		var $data_table = $('.data_table');
		if ($data_table.length) {
			$data_table.each(function() {
				var $faux_header = $(this).parents('.div-padding').find('.faux_header');
			});
			$window.on('scroll', function(e) {
				$data_table.each(function() {
					var $data_table_top = parseInt($(this).offset().top),
						$data_table_bottom = $data_table_top + parseInt($(this).height()),
						$faux_header = $(this).parents('.div-padding').find('.faux_header'),
						$scrollTop = $window.scrollTop();
					if ($data_table_top <= $scrollTop && $data_table_bottom >= $scrollTop) {
						if (!$faux_header.hasClass('sticky')) {
							$faux_header.addClass('sticky')
						}
					} else {
						if ($faux_header.hasClass('sticky')) {
							$faux_header.removeClass('sticky')
						}
					}
				});
			});

			/* $window.on('resize', function(e) {
			     $data_table.each(function() {
			     var $data_table_top = parseInt($data_table.offset().top),
			         $data_table_bottom = $data_table_top + parseInt($data_table.height());
			     }
			 });*/
		}

		//Sticky Contact Bar
		var $top_stick_cta = $('.top_stick_cta');
		if ($top_stick_cta.length) {
			$('.toggle_contact_cta').on('click', function(e) {
				e.preventDefault();
				$top_stick_cta.toggleClass('open');
			});
			$top_stick_cta.find('.close-button').on('click', function(e) {
				e.preventDefault();
				$top_stick_cta.removeClass('open');
			});

			var $header = $('.main_header'),
				$body = $('body'),
				$header_bottom = parseInt($header.offset().top + $header.outerHeight()),
				$lastScroll = $(window).scrollTop(),
				$cta_toggle_content = $('.cta_toggle_content');

			$(window).on('scroll', function(e) {
				/*if ($top_stick_cta.hasClass('open')) {
				    return;
				}*/
				if ($('body').hasClass('menu_open')) {
					return;
				}
				var $currentScroll = $(window).scrollTop();

				if ($lastScroll < $header_bottom) {
					$top_stick_cta.addClass('stick');
					$body.css({
						'margin-top': $cta_toggle_content.outerHeight()
					});
				} else {
					$top_stick_cta.removeClass('stick');
					$body.css({
						'margin-top': 0,
						'position': 'relative'
					})
					$top_stick_cta.removeClass('show');
				}

				if ($lastScroll < $currentScroll) {
					$top_stick_cta.removeClass('show');
					$body.removeClass('cta-open').css({
						'margin-top': 0,
						'position': 'relative'
					});
				} else {
					$top_stick_cta.addClass('show');
					$body.css({
						'margin-top': $cta_toggle_content.outerHeight()
					});
				}

				$lastScroll = $currentScroll;

				/*if ($lastScroll == '0') {
				    $top_stick_cta.removeClass('show');
				    $body.css({
				        'margin-top':'0'
				    });
				}*/
			});
		}

		function set_column_heights() {
			var $equal_height = $('.equal-height');
			if ($equal_height.length) {

				$equal_height.each(function() {
					var $row = $(this),
						$columns = $row.find('.columns');

					$columns.each(function() {
						$(this).css({
							'height': 'auto'
						}).find('.button_wrap').css({
							'width': $(this).width() - 40,
							'margin-left': '0'
						});
					});

					if ($(window).width() > 600) {
						var $row_height = $row.innerHeight();
						$columns.each(function() {
							var $column = $(this);
							$column.css({
								'height': $row_height + 40
							}).addClass('height-adjusted');
						});
					}
				});

			}
		}

		set_column_heights();

		$(window).on('resize', function() {
			set_column_heights();
		});

		function remove_closest_location() {
			$('#current-branch').remove();
		}

		var $dt_modal = $('.dt-modal');
		if ($dt_modal.length) {

			$('body').on('click', '.dt-modal', function(e) {
				e.preventDefault();

				var $formdata = false,
					$formname = $(this).data('form'),
					$step = $(this).data('step'),
					$modals = vex.getAll(),
					$modal = false;

				if ($formname.length) {
					$formdata = $('body').find('form[name=' + $formname + ']').serializeArray();
				}

				//console.log($formdata);

				set_cookies_and_tracking($step, $formdata);

				var data = {
					action: "park_decision_tree",
					formdata: $formdata,
					step: $step
				};

				if ($.isEmptyObject($modals)) {
					var $modal = init_modal();
				} else {
					var $modal = $modals[Object.keys($modals)[0]];
					open_loading_modal($modal);
				}

				$.ajax({
					url: ajax_object.ajax_url,
					type: "POST",
					data: data,
					success: function(data, textStatus, jqXHR) {
						if (data.hasOwnProperty('redirect')) {
							window.location.href = data.redirect;
						}
						set_modal_content($modal, data);
					},
					error: function(jqXHR, textStatus, errorThrown) {
						console.log(jqXHR);
						console.log(textStatus);
						console.log(errorThrown);
					}
				});
			});
		}

		function init_modal() {
			var $modal = vex.open({
				unsafeContent: [
					"<div class=\"modal_breadcrumbs\"></div>",
					"<div class=\"modal_title\"><h3>Loading</h3></div>",
					"<div class=\"modal_content\"><svg class=\"loading_svg\"width=\"38\" height=\"38\" viewBox=\"0 0 38 38\" xmlns=\"http://www.w3.org/2000/svg\" stroke=\"" + ajax_object.primary_color + "\"><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1 1)\" stroke-width=\"2\"><circle stroke-opacity=\".5\" cx=\"18\" cy=\"18\" r=\"18\"/><path d=\"M36 18c0-9.94-8.06-18-18-18\"><animateTransform attributeName=\"transform\" type=\"rotate\" from=\"0 18 18\" to=\"360 18 18\" dur=\"1s\" repeatCount=\"indefinite\"/></path></g></g></svg></div>",
					"<div class=\"modal_buttons\"></div>"
				].join("")
			});
			return $modal;
		}

		function open_loading_modal($modal) {
			set_modal_loading_content($modal);
			return $modal;
		}

		function set_modal_loading_content($modal) {
			var $modal_content_wrap = $($modal.contentEl),
				$modal_breadcrumbs = $modal_content_wrap.find('.modal_breadcrumbs'),
				$modal_title = $modal_content_wrap.find('.modal_title'),
				$modal_content = $modal_content_wrap.find('.modal_content'),
				$modal_buttons = $modal_content_wrap.find('.modal_buttons');

			$modal_breadcrumbs.html('<span></span>');
			$modal_title.html('<h3>Loading</h3>');
			$modal_content.html('<svg class=\"loading_svg\"width=\"38\" height=\"38\" viewBox=\"0 0 38 38\" xmlns=\"http://www.w3.org/2000/svg\" stroke=\"" + ajax_object.primary_color + "\"><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1 1)\" stroke-width=\"2\"><circle stroke-opacity=\".5\" cx=\"18\" cy=\"18\" r=\"18\"/><path d=\"M36 18c0-9.94-8.06-18-18-18\"><animateTransform attributeName=\"transform\" type=\"rotate\" from=\"0 18 18\" to=\"360 18 18\" dur=\"1s\" repeatCount=\"indefinite\"/></path></g></g></svg>');
			$modal_buttons.html('');
		}

		function set_modal_content($modal, data) {
			//console.log($modal);
			//console.log('content');
			var $modal_content_wrap = $($modal.contentEl),
				$modal_breadcrumbs = $modal_content_wrap.find('.modal_breadcrumbs '),
				$modal_title = $modal_content_wrap.find('.modal_title '),
				$modal_content = $modal_content_wrap.find('.modal_content '),
				$modal_buttons = $modal_content_wrap.find('.modal_buttons ');

			$modal_breadcrumbs.html(data.breadcrumbs);
			$modal_title.html('<h3>' + data.title + '</h3>');
			$modal_content.html(data.content);
			$modal_buttons.html(data.buttons);
			$modal_content.find('a.button').focus();
			var $input = $modal_content.find('input');
			if ($input.length > 0) {
				$input.first().focus();
			}
		}

		function set_cookies_and_tracking($step, $formdata) {
			Cookies.set($step, $formdata, {
				expires: 365
			});
			sendDataToAnalytics($step, $formdata);
		}

		function sendDataToAnalytics($step, $formdata) {
			window.dataLayer = window.dataLayer || [];
			var $obj = {},
				$inputs = [];
			for (var input in $formdata) {
				var $value = {
					'name': $formdata[input]['name'],
					'value': $formdata[input]['value']
				};
				$inputs.push($value);
			}
			$obj[$step] = $inputs;
			dataLayer.push($obj);
		}

		$('.more_filters_toggle').find('a').on('click', function(e) {
			e.preventDefault();
			$('.more_filters').slideToggle();
		});

		$('.reset_dt').on('click', function(e) {
			e.preventDefault();
			Cookies.remove('dt_category');
			Cookies.remove('dt_persona');
			window.location.reload();
		});

		//Filter Email links
		$('a[href*="mailto:"]').on('click', function(e) {
			e.preventDefault();

			var $mailto = $(this).attr('href');
			vex.dialog.buttons.YES.text = 'Continue';

			vex.dialog.confirm({
				message: 'This email is not secure, please do not include any confidential information such as social security number, account number or account balance with your submission.',
				callback: function(value) {
					if (value === true) {
						window.location.href = $mailto;
					}
				}
			});

			return false;
		});


		//Filter Email links
		$('body').on('click', '#team_filter--trigger', function(e) {
			e.preventDefault();
			var $filter = $('#team_hero_filter');

			var $content = [
                "<div class=\"modal_title\"><h3>Find A Team Member</h3></div>",
                "<div class=\"modal_content modal_content--t\" style=\"text-align: center;\"></div>"
            ];

			vex.open({
            	unsafeContent: $content.join(""),
                afterOpen: function() {
                    $('.modal_content--t').append($filter).find('#team_hero_filter').css('display', 'block');
                },
                afterClose: function() {
                    $('body').append($filter).find('#team_hero_filter').css('display', 'none');
                }
			});

			return false;
		});

		$.fn.mousetip = function(tip, x, y) {
			var $this = $(this);
			$this.hover(function() {
				$(tip, this).show();
			}, function() {
				$(tip, this).hide().removeAttr('style');
			});
		};
		$('.tooltip_wrap').mousetip('.tooltip--content');

	});

	$(window).resize(function() {
		ul_width();
		equalheight('.vertical_center');
	});

	$(window).load(function() {
		equalheight('.vertical_center');
	});

	//Init Foundation
	$(document).foundation();

	''
})(jQuery, window, document);

(function(){

	/**
	 * Alert Bar functionality
	 */
	var alerts = document.querySelectorAll( '.alert-bar' );
	alerts.forEach( ( alert, index ) => {
		//display alert if not seen
		if( !getCookie( 'saw_alert_bar_' + index ) ){
			showAlert();
		}

		function showAlert(){
			jQuery(alert).slideDown();
			alert.setAttribute( 'role', 'alert' );
		}

		//close and ignore alert
		const close = alert.querySelector('.icon-close');
		close.addEventListener( 'click', hideAlert );

		function hideAlert(e){
			e.preventDefault();
			Cookies.set('saw_alert_bar_' + index, 'true', {
				expires: 1,
				path: '/',
				domain: $cookie_domain
			});

			jQuery(alert).slideUp( 'slow', function(){
				jQuery(alert).remove();
			});
		}
	});

	var body = document.querySelector('body');
	body.classList.add('js-active');

	var accordions = document.querySelectorAll('.accordion');
	accordions.forEach((accordion, index ) => {
		var self = accordion,
			control = self.querySelector('.accordion-control'),
			content = self.querySelector('.accordion-content');

		control.addEventListener( 'click', toggleContent );
		content.setAttribute( 'hidden', '' );

		function toggleContent(e){
			if( 'true' === control.getAttribute( 'aria-expanded' ) ){
				closeContent(e);
			}else{
				openContent(e);
			}
		}

		function openContent(e){
			self.classList.add( 'active' );
			control.setAttribute( 'aria-expanded', true );
			content.removeAttribute( 'hidden' );
		}

		function closeContent(e){
			self.classList.remove( 'active' );
			control.setAttribute( 'aria-expanded', false );
			content.setAttribute( 'hidden', '' );
		}
	});

	var cssSliders = document.querySelectorAll('[data-slider]');
	cssSliders.forEach(( slider, index ) => {
		let activeIndex = 0;
		const container = slider.querySelector(slider.getAttribute('data-slider-container'));
		const elements = [...slider.querySelectorAll(slider.getAttribute('data-slider-items'))];
		const previous = slider.querySelector( '.mobile-slider-wrapper__button--previous' );
		const next = slider.querySelector( '.mobile-slider-wrapper__button--next' );
		var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

		previous.addEventListener( 'click', goPrevious );
		next.addEventListener( 'click', goNext );

		function handleIntersect(entries){
			const entry = entries.find(e => e.isIntersecting);
			if (entry) {
				const index = elements.findIndex(
					e => e === entry.target
				);
				activeIndex = index;
			}
		}

		const observer = new IntersectionObserver(handleIntersect, {
			root: container,
			rootMargin: "0px",
			threshold: 0.75
		});

		elements.forEach(el => {
			observer.observe(el);
		});

		function goPrevious() {
			if(activeIndex > 0) {
				if(!isSafari){
					elements[activeIndex - 1].scrollIntoView({
						behavior: 'smooth',
						block: 'nearest',
						inline: 'nearest'
					})
				}else{
					scrollElementIntoViewHz(elements[activeIndex - 1],'auto')
					activeIndex = activeIndex - 1
				}
			}
		}

		function goNext() {
			if(activeIndex < elements.length - 1) {
				if(!isSafari){
					elements[activeIndex + 1].scrollIntoView({
						behavior: 'smooth',
						block: 'nearest',
						inline: 'nearest'
					})
				}else{
					scrollElementIntoViewHz(elements[activeIndex + 1],'auto')
					activeIndex = activeIndex + 1
				}
			}
		}
	});

	/** Scrolls the element into view
	 * Manually created since Safari does not support the native one inside an iframe
	 */
	const scrollElementIntoViewHz = ( element, behavior ) => {

		let scrollLeft = element.parentElement.scrollLeft

		const finalOffset = element.getBoundingClientRect().left + scrollLeft - 55

		element.parentElement.scrollTo({
			left: finalOffset,
			behavior: behavior || 'auto'
		})
	}

	var footerNavigation = document.querySelector('#footer-navigation');
	if( footerNavigation ){
		setupFooterAccordions( footerNavigation );
	}
	function setupFooterAccordions(container){
		var accordionsActive = false,
			activeWidth = 1023,
			accordions = container.querySelectorAll( '.col-links' );

		function activateAccordions(){
			if( accordionsActive ){
				return;
			}
			accordionsActive = true;
			accordions.forEach((accordion,index) => {
				var trigger = accordion.querySelector( '.navigation-title' ),
					content = accordion.querySelector( '.ft-col-links-wrap' );
				trigger.setAttribute( 'aria-expanded', false );
				trigger.setAttribute( 'aria-controls', trigger.getAttribute( 'data-controls' ) );
				trigger.setAttribute( 'tabindex', 0 );
				trigger.removeAttribute( 'disabled' );
				content.setAttribute( 'hidden', true );
				trigger.addEventListener( 'click', toggleContent );
			});
		}

		function deactivateAccordions(){
			if( !accordionsActive ){
				return;
			}
			accordionsActive = false;
			accordions.forEach((accordion,index) => {
				var trigger = accordion.querySelector( '.navigation-title' ),
					content = accordion.querySelector( '.ft-col-links-wrap' );
				trigger.removeAttribute( 'aria-expanded' );
				trigger.removeAttribute( 'aria-controls' );
				trigger.setAttribute( 'tabindex', -1 );
				trigger.setAttribute( 'disabled', true );
				content.removeAttribute( 'hidden' );
				trigger.removeEventListener( 'click', toggleContent );
			});
		}

		function maybeActivateAccordions(){
			if( window.innerWidth < 1023 ){
				activateAccordions();
			}else{
				deactivateAccordions();
			}
		}

		function toggleContent( e ){
			if( 'true' === e.target.getAttribute( 'aria-expanded' ) ){
				closeContent(e);
			}else{
				openContent(e);
			}
		}

		function openContent( e ){
			e.target.setAttribute( 'aria-expanded', true );
			document.getElementById(e.target.getAttribute('aria-controls')).removeAttribute( 'hidden' );
		}

		function closeContent( e ){
			e.target.setAttribute( 'aria-expanded', false );
			document.getElementById(e.target.getAttribute('aria-controls')).setAttribute( 'hidden', true );
		}

		window.addEventListener( 'resize', maybeActivateAccordions );
		maybeActivateAccordions();
	}

	var accordionGroups = document.querySelectorAll( '[data-accordion-group]' );
	accordionGroups.forEach( (group, index) => {
		var accordions = group.querySelectorAll( '[data-accordion]' );

		accordions.forEach((accordion,index) => {
			var trigger = accordion.querySelector( '[data-accordion-trigger]' ),
				content = accordion.querySelector( '[data-accordion-content]' );
			trigger.setAttribute( 'aria-expanded', false );
			trigger.setAttribute( 'aria-controls', trigger.getAttribute( 'aria-controls' ) );
			trigger.setAttribute( 'tabindex', 0 );
			trigger.removeAttribute( 'disabled' );
			content.setAttribute( 'hidden', true );
			trigger.addEventListener( 'click', function(){
				toggleContent( trigger );
			} );
		});

		function toggleContent( trigger ){
			if( 'true' === trigger.getAttribute( 'aria-expanded' ) ){
				closeContent(trigger);
			}else{
				openContent(trigger);
			}
		}

		function openContent( trigger ){
			trigger.setAttribute( 'aria-expanded', true );
			document.getElementById(trigger.getAttribute('aria-controls')).removeAttribute( 'hidden' );
		}

		function closeContent( trigger ){
			trigger.setAttribute( 'aria-expanded', false );
			document.getElementById(trigger.getAttribute('aria-controls')).setAttribute( 'hidden', true );
		}
	} );
})();

/**
 * Personalization Event Logic
 */
function logichop_page_rendered () {
	var personalizedAreas = document.querySelectorAll('[data-cid]'),
		displayEventLabel = 'pnbPersonalizationDisplayed',
		clickEventLabel = 'pnbPersonalizationCTA';

	//loop through personalized sections
	personalizedAreas.forEach(( section, i ) => {
		var slug = section.getAttribute( 'data-personalization-slug' ),
			eventTitle = section.getAttribute( 'data-personalization-event' );

		//determine if condition is matched or not
		logichop_condition( slug, trueCallback, falseCallback );

		//condition matched
		function trueCallback(){
			dataLayer.push({
				'event': displayEventLabel,
				'category': 'personalization',
				'action': eventTitle,
				'label': 'displayed'
			});
			setupClickListeners();
		}

		function falseCallback(){
		}

		//listen for clicking on links in matched section
		function setupClickListeners(){
			var links = section.querySelectorAll('a');
			links.forEach((link,i) => {
				var value = link.getAttribute( 'href' );
				link.addEventListener( 'click', function(){
					dataLayer.push({
						'event': clickEventLabel,
						'category': 'personalization',
						'action': eventTitle,
						'label': 'click'
					});
				}, false );
			});
		}
	});
}

/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/
(function () {
  var tablist = document.querySelectorAll('[role="tablist"]')[0];
  var tabs;
  var panels;
  var select;

  if( !tablist ) {
  	return;
  }

  var delay = determineDelay();

  // For easy reference
  var keys = {
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    delete: 46
  };

  // Add or substract depending on key pressed
  var direction = {
    37: -1,
    38: -1,
    39: 1,
    40: 1
  };

  generateArrays();
  setupMobileSelector();

  // Bind listeners
  for (var i = 0; i < tabs.length; ++i) {
    addListeners(i);
  };

  if( tabs.length > 0 ){
  	activateTab( tabs[0], false );
  }

  function setupMobileSelector() {
	select = document.querySelector('[data-tab-selector]');
	select.addEventListener('change',function(e){
		console.log( e );
		activateTab( tabs[ e.target.value ] );
	});
  }

  function generateArrays () {
    tabs = document.querySelectorAll('[role="tab"]');
    panels = document.querySelectorAll('[role="tabpanel"]');
  };

  function addListeners (index) {
    tabs[index].addEventListener('click', clickEventListener);
    tabs[index].addEventListener('keydown', keydownEventListener);
    tabs[index].addEventListener('keyup', keyupEventListener);

    // Build an array with all tabs (<button>s) in it
    tabs[index].index = index;
  };

  // When a tab is clicked, activateTab is fired to activate it
  function clickEventListener (event) {
    var tab = event.target;
    activateTab(tab, false);
  };

  // Handle keydown on tabs
  function keydownEventListener (event) {
    var key = event.keyCode;

    switch (key) {
      case keys.end:
        event.preventDefault();
        // Activate last tab
        activateTab(tabs[tabs.length - 1]);
        break;
      case keys.home:
        event.preventDefault();
        // Activate first tab
        activateTab(tabs[0]);
        break;

      // Up and down are in keydown
      // because we need to prevent page scroll >:)
      case keys.up:
      case keys.down:
        determineOrientation(event);
        break;
    };
  };

  // Handle keyup on tabs
  function keyupEventListener (event) {
    var key = event.keyCode;

    switch (key) {
      case keys.left:
      case keys.right:
        determineOrientation(event);
        break;
      case keys.delete:
        determineDeletable(event);
        break;
    };
  };

  // When a tablistâ€™s aria-orientation is set to vertical,
  // only up and down arrow should function.
  // In all other cases only left and right arrow function.
  function determineOrientation (event) {
    var key = event.keyCode;
    var vertical = tablist.getAttribute('aria-orientation') == 'vertical';
    var proceed = false;

    if (vertical) {
      if (key === keys.up || key === keys.down) {
        event.preventDefault();
        proceed = true;
      };
    }
    else {
      if (key === keys.left || key === keys.right) {
        proceed = true;
      };
    };

    if (proceed) {
      switchTabOnArrowPress(event);
    };
  };

  // Either focus the next, previous, first, or last tab
  // depening on key pressed
  function switchTabOnArrowPress (event) {
    var pressed = event.keyCode;

    for (var x = 0; x < tabs.length; x++) {
      tabs[x].addEventListener('focus', focusEventHandler);
    };

    if (direction[pressed]) {
      var target = event.target;
      if (target.index !== undefined) {
        if (tabs[target.index + direction[pressed]]) {
          tabs[target.index + direction[pressed]].focus();
        }
        else if (pressed === keys.left || pressed === keys.up) {
          focusLastTab();
        }
        else if (pressed === keys.right || pressed == keys.down) {
          focusFirstTab();
        };
      };
    };
  };

  // Activates any given tab panel
  function activateTab (tab, setFocus) {
    setFocus = setFocus || true;
    // Deactivate all other tabs
    deactivateTabs();

    // Remove tabindex attribute
    tab.removeAttribute('tabindex');

    // Set the tab as selected
    tab.setAttribute('aria-selected', 'true');

    // Get the value of aria-controls (which is an ID)
    var controls = tab.getAttribute('aria-controls');

    // Remove hidden attribute from tab panel to make it visible
    document.getElementById(controls).removeAttribute('hidden');

    // Set focus when required
    if (setFocus) {
      tab.focus();
    };
  };

  // Deactivate all tabs and tab panels
  function deactivateTabs () {
    for (var t = 0; t < tabs.length; t++) {
      tabs[t].setAttribute('tabindex', '-1');
      tabs[t].setAttribute('aria-selected', 'false');
      tabs[t].removeEventListener('focus', focusEventHandler);
    };

    for (var p = 0; p < panels.length; p++) {
      panels[p].setAttribute('hidden', 'hidden');
    };
  };

  // Make a guess
  function focusFirstTab () {
    tabs[0].focus();
  };

  // Make a guess
  function focusLastTab () {
    tabs[tabs.length - 1].focus();
  };

  // Detect if a tab is deletable
  function determineDeletable (event) {
    target = event.target;

    if (target.getAttribute('data-deletable') !== null) {
      // Delete target tab
      deleteTab(event, target);

      // Update arrays related to tabs widget
      generateArrays();

      // Activate the closest tab to the one that was just deleted
      if (target.index - 1 < 0) {
        activateTab(tabs[0]);
      }
      else {
        activateTab(tabs[target.index - 1]);
      };
    };
  };

  // Deletes a tab and its panel
  function deleteTab (event) {
    var target = event.target;
    var panel = document.getElementById(target.getAttribute('aria-controls'));

    target.parentElement.removeChild(target);
    panel.parentElement.removeChild(panel);
  };

  // Determine whether there should be a delay
  // when user navigates with the arrow keys
  function determineDelay () {
    var hasDelay = tablist.hasAttribute('data-delay');
    var delay = 0;

    if (hasDelay) {
      var delayValue = tablist.getAttribute('data-delay');
      if (delayValue) {
        delay = delayValue;
      }
      else {
        // If no value is specified, default to 300ms
        delay = 300;
      };
    };

    return delay;
  };

  //
  function focusEventHandler (event) {
    var target = event.target;

    setTimeout(checkTabFocus, delay, target);
  };

  // Only activate tab on focus if it still has focus after the delay
  function checkTabFocus (target) {
    focused = document.activeElement;

    if (target === focused) {
      activateTab(target, false);
    };
  };
}());

/**
 * Member page sections with show all links
 */
(function(){
	var sections = document.querySelectorAll('.member__section');
	sections.forEach((section, index ) => {
		var groups = section.querySelectorAll( '[data-section-load-more-group]' ),
			viewAll = section.querySelectorAll( '[data-section-load-more]' );
		if ( groups.length > 1 ) {
			groups.forEach(( group, index ) => {
				if( 0 !== index ) {
					group.setAttribute( 'hidden', true );
				}
			});
			viewAll.forEach(( link ) => {
				link.addEventListener( 'click', function( e ){
					link.remove();
					groups.forEach(( group ) => {
						group.removeAttribute( 'hidden' );
					});
				});
			});
		} else {
			viewAll.forEach(( link ) => {
				link.setAttribute( 'hidden', true );
			});
		}
	});
}());

/**
 * Member experience height cap
 */
(function(){
	var heightCaps = document.querySelectorAll( '[data-height-cap]' );
	heightCaps.forEach(( section, index ) => {
		var height = section.getAttribute( 'data-height-cap' ),
			currentHeight = section.clientHeight,
			loadMore = document.querySelectorAll( '[href="#' + section.getAttribute( 'id' ) + '"]' );
		if ( currentHeight > height ) {
			section.style.height = height + "px";
			loadMore.forEach(( link ) => {
				link.addEventListener( 'click', function( e ){
					e.preventDefault();
					link.remove();
					section.style.height = "auto";
				});
			});
		} else {
			loadMore.forEach(( link ) => {
				link.remove();
			});
		}
	});
}());

/**
 * Set custom validity messages on search fields with a validity attribute
 */
(function(){
	document.querySelectorAll('[type="search"],[data-validity-message]').forEach(element => {
		element.addEventListener('invalid',() => {
			let msg = element.getAttribute('data-validity-message') || 'How can we help you?';
			if( '' == element.value ){
				element.setCustomValidity(msg);
			}else{
				element.setCustomValidity('');
			}
		});
		element.addEventListener('input',() => {
			element.setCustomValidity('');
		});
	});
}());

(function(){
	/**
	 * Google places input and validation - note this does not autosubmit as previous iteration
	 */
	document.querySelectorAll('[data-place-search]').forEach(element => {
		let form = element.closest('form'),
			id = element.getAttribute('id'),
			latInput = document.querySelector(`[data-place-latitude="${id}"]`),
			longInput = document.querySelector(`[data-place-longitude="${id}"]`),
			places_options = {
				types: ['geocode'],
				fields: ['geometry']
			};

		//setup google places
		let places_autocomplete = new google.maps.places.Autocomplete(element, places_options);
		places_autocomplete.addListener('place_changed', function(){
			var place = places_autocomplete.getPlace();
			if( place.geometry ){
				latInput.value = place.geometry.location.lat();
				longInput.value = place.geometry.location.lng();
				element.setCustomValidity('');
			}
		});

		//hide error message on changes or navigation keys within dropdown
		element.addEventListener('keydown', (e) => {
			element.setCustomValidity('');
		});

		//reset error message if attempt to submit without choosing location
		form.addEventListener('submit',(e) => {
			if ( latInput.value == '' || longInput.value == '' ) {
				element.setCustomValidity('Please search and select from the dropdown.');
				element.reportValidity();
				e.preventDefault();
			}
		});
	});
}());

/**
 * Make sure alerts can be seen behind fixed mobile header
 */
(function(){
	let mobileHeader = document.querySelector('#mobile-header'),
		body = document.querySelector('body');
	function resetBodyPadding() {
		let height = mobileHeader.clientHeight;
		body.style.paddingTop = `${height}px`;
	}
	resetBodyPadding();
	window.addEventListener('resize', () => {
		resetBodyPadding();
	});
}());

/**
(function(){
}());
*/